export const INVENTORY_CREATE_ACTION = "INVENTORY_CREATE_ACTION";
export const INVENTORY_LIST_ACTION = "INVENTORY_LIST_ACTION";
export const INVENTORY_LIST_SUCCESS = "INVENTORY_LIST_SUCCESS";
export const INVENTORY_GET_UPDATE_ACTION = "INVENTORY_GET_UPDATE_ACTION";
export const INVENTORY_GET_UPDATE_SUCCESS = "INVENTORY_GET_UPDATE_SUCCESS";
export const INVENTORY_DELETE_ACTION = "INVENTORY_DELETE_ACTION";
export const INVENTORY_UPDATE_ACTION = "INVENTORY_UPDATE_ACTION";

export const INVENTORY_GET_LIST_ACTION = "INVENTORY_GET_LIST_ACTION";
export const INVENTORY_GET_LIST_SUCCESS = "INVENTORY_GET_LIST_SUCCESS";
export const INVENTORY_GET_LIST_FAIL = "INVENTORY_GET_LIST_FAIL";
export const INVENTORY_DETAIL_ACTION = "INVENTORY_DETAIL_ACTION";
export const INVENTORY_DETAIL_SUCCESS = "INVENTORY_DETAIL_SUCCESS";
export const INVENTORY_DETAIL_FAIL = "INVENTORY_DETAIL_FAIL";
export const INVENTORY_DETAIL_UPDATE_ACTION = "INVENTORY_DETAIL_UPDATE_ACTION";
export const INVENTORY_DETAIL_CREATE_ACTION = "INVENTORY_DETAIL_CREATE_ACTION";
export const INVENTORY_DETAIL_DELETE_ACTION = "INVENTORY_DETAIL_DELETE_ACTION";
